export default Backbone.Router.extend({
	unsecure: [],

	// doit être identifié, sauf si destination dans this.unsecure
	execute: function( callback, args, name )
	{
		if( !app.is('authenticated') && !_.contains( this.unsecure, name ) )
		{
			Backbone.history.loadUrl( 'default/login' );
			return;
			var back = Backbone.history.getHash();
// 			return app.redirect( 'default/login' );
			app.redirect('default/login');
			app.view.back = back;
			return;
		}

		if (callback) callback.apply( this, args );
	},
});
